import { FC } from 'react'
import styles from './burger.module.scss'
import Button from '@/components/ui/Button'
import BurgerIcon from '@/components/icons/BurgerIcon'

type BurgerProps = {
  onOpenBurgerMenu: () => void
}

const Burger: FC<BurgerProps> = ({ onOpenBurgerMenu: handleOpenBurgerMenu }) => {
  return (
    <Button
      onClick={handleOpenBurgerMenu}
      aria-label="Открыть меню"
      className={styles.burger}
      icon={<BurgerIcon />}
    />
  )
}

export default Burger
